import React, { useEffect, useState } from "react";
import TaskInformation from "../TaskInformation";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import PreviewButton from "../PreviewButton";
import ValidationButton from "../ValidationButton";
import {updateReparationMission} from "../../../store/action/claimManagement";
import {useDispatch, useSelector} from "react-redux";
import {completeTask, getTask} from "../../../store/action/taskAction";
import {fetchClaimDataAppExpert} from "../../../store/action/claim";
import {useNavigate, useParams} from "react-router-dom";
import ErrorsAlert from "../../../utils/errorsAlert";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        position: 'relative',

    },
    paper: {
        display: "flex",
        borderRadius: "11px",
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
    },
    leftSection: {
        flex: 1,
        padding: "40px",
    },
    rightSection: {
        flex: 1,
        padding: "20px",
    },
    inputLabel: {
        color: 'rgba(70, 78, 95, 1)',
        fontWeight: 400,
        fontFamily: 'Poppins',
        fontSize: 12
    },
    inputTextArea: {
        width: "100%",
        marginBottom: "20px",
    },
    inputContainer: {
        border: 'rgba(243, 246, 249, 1)',
        background: 'rgba(243, 246, 249, 1)',
        width: "100%",
        height: '36px',
        borderRadius: 4,
        marginBottom: "20px",
    },
    previewBtn: {
        position: 'absolute',
        right: '-165px',
    },
    mainContent: {
        width: '95%',
        display: 'flex',
        flexDirection: 'column',
    }
}));

const ReparationEntryDateIndication = () => {
    const { taskId } = useParams();
    const navigate = useNavigate();
    const [isTaskClaimed, setIsTaskClaimed] = useState(true);
    const [comment, setComment] = useState("");
    const [dateStartReparation, setDateStartReparation] = useState("");
    const [estimatedCompletionDate, setEstimatedCompletionDate] = useState("");
    const [claimMissionExpertId , setClaimMissionExpertId] = useState("");
    const classes = useStyles();
    const dispatch = useDispatch();

    const username = localStorage.getItem('username');
    const taskReducer = useSelector((state) => state.taskReducer.taskList.find(task => task?.taskId === taskId));
    const [task, setTask] = useState(taskReducer);
    

    const [variables, setVariables] = useState(task?.variables)
    const [infoSinistre, setInfoSinistre] = useState(task?.businessKey)
    const [immatriculation, setImmatriculation] = useState(task?.variables?.immatriculation?.value)
    const [starClaimData, setStarClaimData] = useState(null);
    const repartionMissionId = task?.variables?.repartionMissionId?.value;
    const [openErrorDialog, setOpenErrorDialog] = useState(false);
    const [errors, setErrors] = useState([]);

    const handleClose = () => {
        setOpenErrorDialog(false);
        setErrors([]);
    };

    const getClaimData = async (claimMissionExpertId) => {
        try {
            const data = await fetchClaimDataAppExpert(claimMissionExpertId); 
            setStarClaimData(data);
        } catch (error) {
            console.error("Error fetching claim data:", error);
        }
    };
    const fetchTask = async () => {
        try {
            const response = await getTask(taskId, username);
            setTask(response)
            setInfoSinistre(response?.businessKey)
            setImmatriculation(response?.variables?.immatriculation?.value)
            setVariables(response?.variables)
        } catch (error) {
            console.error(`Error fetching task details: ${error.message}`);
        }
    };

    useEffect(() => {
        if (task?.assignee === username) {
            setIsTaskClaimed(false);
        } else {
            setIsTaskClaimed(true);
        }
        setClaimMissionExpertId(task?.variables?.claimExpertId?.value)
        getClaimData(task?.variables?.claimExpertId?.value);
        fetchTask();
    }, [dispatch, taskId, username]);

    // const calculateEstimatedCompletionDate = (startDate, immobilizationDuration) => {
    //     const start = new Date(startDate);
    //     start.setDate(start.getDate() + immobilizationDuration);
    //     return start.toISOString().split('T')[0];
    // };
    //
    // useEffect(() => {
    //     if (dateStartReparation && starClaimData) {
    //         const immobilizationDuration = starClaimData?.damageCalculation?.report?.immDays || 0;
    //         const estimatedDate = calculateEstimatedCompletionDate(dateStartReparation, immobilizationDuration);
    //         setEstimatedCompletionDate(estimatedDate);
    //     }
    // }, [dateStartReparation, starClaimData]);
    const validateInputs = () => {
        const validationErrors = [];

        if (!dateStartReparation) {
            validationErrors.push("La date de début de réparation est requise");
        } else {
            const startDate = new Date(dateStartReparation);
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            if (startDate < today) {
                validationErrors.push("La date de début de réparation ne peut pas être dans le passé");
            }
        }

        if (!estimatedCompletionDate) {
            validationErrors.push("La date de fin estimée de réparation est requise");
        } else if (dateStartReparation) {
            const startDate = new Date(dateStartReparation);
            const endDate = new Date(estimatedCompletionDate);

            if (endDate <= startDate) {
                validationErrors.push("La date de fin doit être postérieure à la date de début");
            }
        }
        return validationErrors;
    };

    const ValidationAction = async () => {
        const validationErrors = validateInputs();
        if (validationErrors.length > 0) {
            setErrors(validationErrors);
            setOpenErrorDialog(true);
            return;
        }

        try {
            //let variables = {};

            const repartitionObject = {
                estimatedReparationEntryDate: dateStartReparation,
                estimatedReparationEndDate: estimatedCompletionDate,
                comment,
            };

            await updateReparationMission(repartionMissionId, repartitionObject);
            await dispatch(completeTask(taskId, username, variables));
            navigate('/todo-list', { reload: true });
        } catch (error) {
            console.error(error);
            validationErrors.push("Erreur lors de la validation. Veuillez réessayer.");
        }
    };




    return (
        <div className={classes.root}>
            <div style={{display: 'flex'}}>
            <div className={classes.mainContent}>
                <TaskInformation taskId={taskId} onClaimStatusChange={setIsTaskClaimed} />
                <Paper className={classes.paper}>
                    <div className={classes.leftSection}>
                        <div>
                            <label className={classes.inputLabel}>Date début de reparations</label>
                            <input
                                className={classes.inputContainer}
                                name="dateStartReparation"
                                min={task?.variables?.openingDate?.value}
                                type="date"
                                disabled={isTaskClaimed}
                                value={dateStartReparation}
                                onChange={(e) => setDateStartReparation(e.target.value)}
                                placeholder=""
                                style={{background: 'rgba(243, 246, 249, 1)'}}
                            />
                        </div>
                        <div>
                            <label className={classes.inputLabel}>Immobilisation</label>
                            <input
                                className={classes.inputContainer}
                                name="immobilisation"
                                disabled
                                value={
                                    starClaimData
                                        ? `${starClaimData.damageCalculation?.report?.immDays} Jours`
                                        : '-'
                                }
                            />
                        </div>
                        <div>
                            <label className={classes.inputLabel}>Date fin de réparation</label>
                            <input
                                className={classes.inputContainer}
                                name="dateEndReparation"
                                type="date"
                                min={dateStartReparation}
                                disabled={isTaskClaimed}
                                value={estimatedCompletionDate}
                                onChange={(e) => setEstimatedCompletionDate(e.target.value)}
                                placeholder=""
                                style={{background: 'rgba(243, 246, 249, 1)'}}
                            />
                        </div>
                    </div>
                    <div className={classes.rightSection}>
                        <label className={classes.inputLabel}>Commentaire</label>
                        <br/>
                        <textarea
                            className={classes.inputTextArea}
                            style={{
                                background: "rgba(243, 246, 249, 1)",
                                width: "519px",
                                height: 352,
                                borderRadius: "4px",
                                border: "none",
                                outline: "none",
                                padding: "40px",
                            }}
                            disabled={isTaskClaimed}
                            onChange={(e) => setComment(e.target.value)}
                        ></textarea>
                    </div>
                </Paper>
            </div>
            <PreviewButton claimData={infoSinistre} 
              immatriculation={immatriculation}
            />
        </div>
            <ValidationButton taskId={taskId} handleValidation={() =>isTaskClaimed? null : ValidationAction()} />
            <ErrorsAlert
                open={openErrorDialog}
                errors={errors}
                handleClose={handleClose}
            />
        </div>
    );
};

export default ReparationEntryDateIndication;
